



















































































import Vue from 'vue'
import ChatWidgetInstruction from './ChatWidgetInstruction.vue'
import { i18n } from '../../../localization'

export default Vue.extend({
  props: ['websiteScreenshot', 'cms'],
  components: {
    ChatWidgetInstruction,
  },
  data() {
    return {
      sending: false,
      hasAccess: undefined,
      showModal: false,
      modalType: 'steps',
      showInstructionModal: false,
      currentLocationId: '',
      cmsName: this.cms,
      cmsData: {} as any,
      cmsInstructions: {
        wordpress: {
          heading: i18n.t('launchpad.chatWidgetWordpressTitle'),
          steps: [
            {
              text: i18n.t('launchpad.chatWidgetWordpressStep1'),
              img: 'wordpress.png',
              logo: true,
            },
            {
              text: i18n.t('launchpad.chatWidgetWordpressStep2'),
              img: 'WordPress0-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetWordpressStep3'),
              img: 'WordPress1-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetWordpressStep4'),
              img: 'WordPress2-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetWordpressStep5'),
              img: 'WordPress3-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetWordpressStep6'),
              img: undefined,
              apiKey: true,
            },
            {
              text: i18n.t('launchpad.chatWidgetWordpressStep7'),
              img: 'WordPress4-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetWordpressStep8'),
              img: 'WordPress5-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetWordpressStep9'),
              img: 'WordPress6-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetWordpressStep10'),
              img: 'WordPress7-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetCheckInstallation'),
              screenshot: true,
            },
          ],
        },
        squarespace: {
          heading: i18n.t('launchpad.chatWidgetSquareSpaceTitle'),
          steps: [
            {
              text: i18n.t('launchpad.chatWidgetSquareSpaceStep1'),
              img: 'squarespace.png',
              logo: true,
            },
            {
              text: i18n.t('launchpad.chatWidgetSquareSpaceStep2'),
              img: 'Squarespace0-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetSquareSpaceStep3'),
              img: 'Squarespace1-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetCopyCode'),
              img: undefined,
              widgetCode: true,
            },
            {
              text: i18n.t('launchpad.chatWidgetSquareSpaceStep5'),
              img: 'Squarespace2-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetSquareSpaceStep6'),
              img: 'Squarespace3-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetClickSave'),
              img: 'Squarespace4-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetCheckInstallation'),
              screenshot: true,
            },
          ],
        },
        joomla: {
          heading: i18n.t('launchpad.chatWidgetJoomlaTitle'),
          steps: [
            {
              text: i18n.t('launchpad.chatWidgetJoomlaStep1'),
              img: 'joomla.png',
              logo: true,
            },
            {
              text: i18n.t('launchpad.chatWidgetJoomlaStep2'),
              img: 'Joomla0-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetJoomlaStep3'),
              img: 'Joomla1-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetJoomlaStep4'),
              img: 'Joomla2-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetJoomlaStep5'),
              img: 'Joomla3-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetCopyCode'),
              img: undefined,
              widgetCode: true,
            },
            {
              text: i18n.t('launchpad.chatWidgetJoomlaStep7'),
              img: 'Joomla4-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetJoomlaStep8'),
              img: 'Joomla5-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetJoomlaStep9'),
              img: 'Joomla7-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetJoomlaStep10'),
              img: 'Joomla8-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetClickSave'),
              img: 'Joomla9-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetCheckInstallation'),
              screenshot: true,
            },
          ],
        },
        duda: {
          heading: i18n.t('launchpad.chatWidgetJoomlaDudaTitle'),
          steps: [
            {
              text: i18n.t('launchpad.chatWidgetJoomlaDudaStep1'),
              img: 'duda.png',
              logo: true,
            },
            {
              text: i18n.t('launchpad.chatWidgetJoomlaDudaStep2'),
              img: 'Duda0-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetJoomlaDudaStep3'),
              img: 'Duda1-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetCopyCode'),
              img: undefined,
              widgetCode: true,
            },
            {
              text: i18n.t('launchpad.chatWidgetJoomlaDudaStep5'),
              img: 'Duda2-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetClickSave'),
              img: 'Duda3-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetJoomlaDudaStep7'),
              img: 'Duda4-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetCheckInstallation'),
              screenshot: true,
            },
          ],
        },
        shopify: {
          heading: i18n.t('launchpad.chatWidgetShopifyTitle'),
          steps: [
            {
              text: i18n.t('launchpad.chatWidgetShopifyStep1'),
              img: 'shopify.png',
              logo: true,
            },
            {
              text: i18n.t('launchpad.chatWidgetShopifyStep2'),
              img: 'Shopify0-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetShopifyStep3'),
              img: 'Shopify1-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetCopyCode'),
              img: undefined,
              widgetCode: true,
            },
            {
              text: i18n.t('launchpad.chatWidgetShopifyStep5'),
              img: 'Shopify2-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetShopifyStep6'),
              img: 'Shopify3-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetClickSave'),
              img: 'Shopify4-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetCheckInstallation'),
              screenshot: true,
            },
          ],
        },
        weebly: {
          heading: i18n.t('launchpad.chatWidgetWeeblyTitle'),
          steps: [
            {
              text: i18n.t('launchpad.chatWidgetWeeblyStep1'),
              img: 'weebly-logo-2.png',
              logo: true,
            },
            {
              text: i18n.t('launchpad.chatWidgetWeeblyStep2'),
              img: 'Weebly1-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetWeeblyStep3'),
              img: 'Weebly2-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetCopyCode'),
              img: undefined,
              widgetCode: true,
            },
            {
              text: i18n.t('launchpad.chatWidgetWeeblyStep5'),
              img: 'Weebly3-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetWeeblyStep6'),
              img: 'Weebly4-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetClickSave'),
              img: 'Weebly5-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetWeeblyStep8'),
              img: 'Weebly6-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetCheckInstallation'),
              screenshot: true,
            },
          ],
        },
        other: {
          heading: i18n.t('launchpad.chatWidgetOtherTitle'),
          steps: [
            {
              text: i18n.t('launchpad.chatWidgetOtherStep1'),
              img: 'Other1-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetCopyCode'),
              img: undefined,
              widgetCode: true,
            },
            {
              text: i18n.t('launchpad.chatWidgetOtherStep3'),
              img: 'Other2-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetOtherStep4'),
              img: 'Other2-min.png',
            },
            {
              text: i18n.t('launchpad.chatWidgetCheckInstallation'),
              screenshot: true,
            },
          ],
        },
      },
    }
  },
  computed: {
    disableAction(): boolean {
      return this.hasAccess === undefined
    },
  },
  mounted() {
    this.$root.$on('set-cms', (cms: any) => {
      this.cmsName = cms
      this.cmsData = this.cmsInstructions[cms.toLowerCase()]
    })
    this.cmsData = this.cmsInstructions[this.cms.toLowerCase()]
    this.$root.$on('close-modal', () => {
      this.modalType = 'steps'
      this.showModal = false
    })
    this.$root.$on('modal-type', (type: string) => {
      this.showModal = true
      this.modalType = type
    })
    if (this.cmsName.toLowerCase() == 'other') {
      this.changeCms()
    }
  },
  watch: {
    cms: async function () {
      this.cmsName = this.cms
      this.cmsData = this.cmsInstructions[this.cms.toLowerCase()]
    },
  },
  methods: {
    backToLaunchpad() {
      this.$root.$emit('hide-widget-setup')
    },
    showSteps() {
      this.showModal = true
      if (this.hasAccess == 'yes') {
        this.modalType = 'steps'
      } else {
        this.modalType = 'send-instructions'
      }
    },
    changeCms() {
      this.showModal = true
      this.modalType = 'cms-select'
    },
  },
})
